export default __webpack_public_path__ + "static/media/grid.004.8c25bd4b.jpeg";